import React from "react";
import { cn } from "~/utils";
import Button from "~/components/parts/Button";
import Modal from "~/components/parts/Modal";

const ConfirmDialog = ({
  buttonText = "Confirm",
  children,
  className,
  hideCancel = false,
  onCancel,
  onConfirm,
  open,
  title = "",
}) => (
  <Modal
    open={open}
    className={cn("h-auto", className)}
    closeModal={onCancel}
  >
    <div className="flex flex-col gap-4">
      {title && (
        <p className="m-0 text-lg font-light text-slate-500">{title}</p>
      )}
      <div className="text-sm text-slate-700">{children}</div>
      <div className="mt-4 flex justify-end gap-4">
        {!hideCancel && (
          <Button
            className="w-[100px] bg-white p-1.5 text-sm text-red-800 outline-red-100 transition hover:bg-slate-50"
            onClick={onCancel}
          >
            Cancel
          </Button>
        )}
        <Button
          className="w-[100px] bg-blue-500 p-1.5 text-sm text-white shadow-sm hover:bg-blue-500"
          onClick={onConfirm}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  </Modal>
);

export default ConfirmDialog;
